import React, { useEffect, useState } from 'react'
import Couresel_img from '../Images/couresel.jpg'
import Couresel_img3 from '../Images/C_3_replacement.jpeg'
import Npdc from '../Images/npdc1.png'
import Agip from '../Images/agip-logo.png'
import Hydro from '../Images/hydroserve1.png'
import Nlng from '../Images/nlng.png'
import Shell from '../Images/shell.png'
import Total from '../Images/total.png'
import Cl_1 from '../Images/CL_1.jpg'
import Cl_2 from '../Images/CL_2.jpg'
import Cl_3 from '../Images/CL_3.jpeg'
import Cl_4 from '../Images/CL_4.png'
import Value_img from '../Images/value_Img.jpg'
import Rectangle2 from '../Images/Rectangle2.png'
import Navbar from '../componenets/Navbar'
import Footer from '../componenets/Footer'
import { FiArrowUpRight } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import WOW from "wowjs";
import "animate.css";
import Marquee from "react-fast-marquee";

const Home = () => {

  const slides = [
    {
      id: 1,
      title: "Proven Field Success",
      subtitle: "Through Innovation",
      text: "We deliver advanced manufacturing and construction solutions that meet global standards, ensuring innovation and quality every step of the way.",
      image: Couresel_img 
    
    },
    {
      id: 2,
      title: "Indigenous Expertise.",
      subtitle: "Global Standards.",
      text: "Our expert teams combine modern technology and sustainability practices to deliver efficient and eco-friendly engineering results.",
      image: Couresel_img,
    },
   
  ];


  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(false);

  // const prevSlide = React.useCallback(() => {
  //   setFade(true);
  //   setTimeout(() => {
  //     setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  //     setFade(false);
  //   }, 100);
  // }, [slides.length, setCurrent]);   // <-- added setCurrent
  
  const nextSlide = React.useCallback(() => {
    setFade(true);
    setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
      setFade(false);
    }, 100);
  }, [slides.length]);
  
  
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 3000);
  
    return () => clearInterval(timer);
  }, [nextSlide]);
  


  


  const values = [
  {
    title: "Quality Service",
    description: "We deliver far above the expectations of our clients.",
  },
  {
    title: "Reduced Cost",
    description: "Giving you the best costs with regards to quality.",
  },
  {
    title: "Best Practices",
    description:
      "Committed to best professional practices ranging from proper EIA to harnessing adequate safety measures.",
  },
  {
    title: "Qualified Personnel",
    description:
      "Our personnel strictly adhere to due processes, guiding rules, and proffer quick responsive solutions.",
  },
];

useEffect(() => {
  new WOW.WOW({
    live: false
  }).init();
}, []);



  return (
    <div>
        <Navbar />



      <div className="hero-container" style={{ backgroundImage: `url(${slides[current].image})` }}>
      <div className="overlay">
        <div className={`text-content ${fade ? "fade" : "fade-in"}`}>
          <h1>
            {slides[current].title} <br />{" "}
            <span>{slides[current].subtitle}</span>
          </h1>
          {/* <p>{slides[current].text}</p> */}
            <Link to="/contact">
              <div className="contactBtn">
                <button className="contact-btn">
                    Contact us
                </button>
                <button className="contact-btn small_Screen">
                    <FiArrowUpRight  size={24}/>
                </button>
            </div>
          </Link>
        </div>

        {/* <div className="nav-buttons">
          <button onClick={prevSlide}>&larr;</button>
          <button onClick={nextSlide}>&rarr;</button>
        </div> */}
      </div>
    </div>

    <div className="top_company ">
      <div className="the_text_carrier wow animate__animated animate__fadeInUp">
        <div className="orangeline"></div><span>Trusted By Top Companies in the Field</span><div className="orangeline"></div>
      </div>

      <Marquee>
        <div className="company_logo wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
          <div className="imgcarrier">
              <img src={Total} alt="Total" />
              <img src={Shell} alt="Shell" />
              <img src={Npdc} alt="Npdc" />
              <img src={Nlng} alt="NLNG" />
              <img src={Hydro} alt="Hydroserve" />
              <img src={Agip} alt="Agip" />
              <img src={Cl_1} alt="Npdc" />
              <img src={Cl_2} alt="NLNG" />
              <img src={Cl_3} alt="Hydroserve" />
              <img src={Cl_4} alt="Agip" />
          </div>
        </div>
      </Marquee>

    </div>

    <div className="embrace_carrier">
      <div className="embrace_img wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
        <img src={Rectangle2} alt="img" height="600"/>
      </div>
      <div className="embrace_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <h1>We embrace integrity, competency and professionalism</h1>
        <p>We are a local company with global best practices and processes designed to be repeatable. We implement integrated Project Management by identifying project goals, identifying risks and reviewing mitigation plans and identifying dependencies.</p>
        <p>We embrace integrity, competency and professionalism by employing highly qualified personnel, unparalleled training, and committing to clients’ goals and outcomes.</p>
        
          
        <div className="contactBtn">
                <button className="contact-btn">
                    Learn More
                </button>
                <button className="contact-btn small_Screen">
                    <FiArrowUpRight  size={24}/>
                </button>
            </div>
      </div>
    </div>

    <div className="section_wrapper">
      <div className="embrace_carriers">
        <div className="embrace_img">
        <div className="we_are_comitted wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
        <h3>We are commited to Clients’ Goals and Outcomes</h3></div>
        </div>
        <div className="embrace_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
          <p>At WellClean Oil Field Services Limited, we provide quality services to companies in the upstream sector of the Nigerian Oil and Gas industry. Our extensive range of services include production drilling, conductor piling, casting/tubing running, mud logging, well overhauling/stimulation, webore clean up, filtration, well crises management services and other drilling services.</p>
        </div>
      </div>
    </div>

    <div className="value_text_carrier">
      <h2 className="values-title wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">Our Values</h2>

    <div className="value_section">
      <div className="value_text">
       <div className="values-section">
          <div className="values-container wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <div className="values-list">
              {values.map((item, index) => (
                <div key={index} className="value-item">
                  <div className="circle"></div>
            <div className="line"></div>
                  <div className="text">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="value_img wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
        <img src={Value_img} alt="img" height="450"/>
      </div>
    </div>
    </div>

    <Footer />

    </div>
  )
}

export default Home